import api from '@/api'
import * as types from './types'

export default {
  setSearchTerm({
    commit
  }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({
    commit
  }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({
    commit
  }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({
    commit
  }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setStatus({
    commit
  }, status) {
    commit(types.SET_STATUS, status)
  },
  setFilterBy({
    commit
  }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  async getServiceRequests({ commit, dispatch }, searchOptions) {
    return new Promise((resolve, reject) => {
      api.getServiceRequests(searchOptions)
        .then(response => {
          commit(types.SET_SERVICE_REQUESTS, response.data)
          resolve(response)
        })
    })
  },
  async backDateServiceRequest({ commit, dispatch }, workOrder) {
    return new Promise((resolve, reject) => {
      api.backDateServiceRequest(workOrder)
        .then(response => {
          resolve(response)
        })
    })
  },
  async getServiceRequestsForList({ commit, dispatch }, searchOptions) {
    return new Promise((resolve, reject) => {
      api.getServiceRequestsForList(searchOptions)
        .then(response => {
          commit(types.SET_SERVICE_REQUESTS, response.data)
          resolve(response)
        })
    })
  },
  async getServiceRequest({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      api.getServiceRequest(id)
        .then(response => {
          commit(types.SET_SERVICE_REQUEST, response.data)
          resolve(response)
        })
    })
  },
  async getServiceRequestHistory({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      api.getServiceRequestHistory(id)
        .then(response => {
          commit(types.SET_SERVICE_REQUEST_HISTORY, response.data)
          resolve(response)
        })
    })
  },
  async getServiceRequestIssues({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      api.getServiceRequestIssues(id)
        .then(response => {
          commit(types.SET_SERVICE_REQUEST_ISSUES, response.data)
          resolve(response)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/actions.js